var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 23,
  viewBox: "0 0 18 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.60163 1L1.06138 9.49916C1.01093 9.62048 0.991105 9.75236 1.00367 9.88315C1.01623 10.0139 1.06079 10.1396 1.13342 10.2491C1.20605 10.3586 1.30452 10.4486 1.42013 10.511C1.53574 10.5735 1.66494 10.6065 1.79633 10.6072H6.19963L2.99723 21.8156L16.7499 8.78663C16.8658 8.67692 16.9462 8.53511 16.9809 8.37939C17.0155 8.22367 17.0029 8.06113 16.9446 7.91264C16.8862 7.76415 16.7849 7.63647 16.6535 7.54599C16.5221 7.4555 16.3667 7.40633 16.2071 7.40479H10.2058L13.4082 1H4.60163Z",
  stroke: "#333333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgLightning;